import { ReactElement } from 'react';

import { Dropdown, usePush } from '@dreryk/react-components';

import { PRIVATE_MEDICAL_SERVICE_PATH } from '../routes';
import { mainMenuTranslationKeys } from '../translations';

export const PrivateMedicalServiceViewDropdownItem = (): ReactElement => {
   const push = usePush();

   return (
      <Dropdown.Item
         onClick={(hide) => {
            push(PRIVATE_MEDICAL_SERVICE_PATH);
            hide();
         }}
         testId={'privateMedicalService'}
      >
         {mainMenuTranslationKeys.viewDropdownItem.label}
      </Dropdown.Item>
   );
};
